import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn';

const LINK =
  'text-[11px] font-extrabold uppercase tracking-[0.04em] text-accent transition hover:opacity-80';

export interface LinkButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

/** Text-only action button, styled as an inline link. */
export function LinkButton({ className, type = 'button', children, ...props }: LinkButtonProps) {
  return (
    <button type={type} className={cn(LINK, className)} {...props}>
      {children}
    </button>
  );
}

/** The same treatment for real navigation. */
export function TextLink({
  to,
  className,
  children,
}: {
  to: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link to={to} className={cn(LINK, className)}>
      {children}
    </Link>
  );
}
